import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Header from '../Header/Header';

export class DedicatedWorkflowPanel extends React.Component {
  renderInstruction() {
    if (this.props.instruction) {
      return (
          <p className="card-text" id="pageInstruction"><FormattedMessage { ...this.props.instruction } /></p>
      );
    }

    return null;
  }

  renderHeader() {
    let header = null;
    if (this.props.instruction) {
      header = (<Header ariaDescribedby="pageInstruction"
        headerTitle={ <FormattedMessage { ...this.props.headerTitle } />}
        hasMessageDisplay
        headerClassName={this.props.headerClassName}
      />);
    } else {
      header = (<Header
        headerTitle={ <FormattedMessage { ...this.props.headerTitle } />}
        hasMessageDisplay
        headerClassName={this.props.headerClassName}
      />);
    }
    return header;
  }

  render() {
    return (
          <div className="col">
            <div className="row justify-content-md-center mt-3">
                    <div className="col-md-8">
                      {this.renderHeader()}
                      <div className="card p-3">
                          <div className="card-body">
                            { this.renderInstruction() }
                            { this.props.children }
                          </div>
                      </div>
                    </div>
            </div>
          </div>
    );
  }
}

DedicatedWorkflowPanel.propTypes = {
  dispatch: PropTypes.func,
  headerTitle: PropTypes.object,
  headerClassName: PropTypes.string,
  instruction: PropTypes.object,
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
  ]),
};